import { z } from 'zod';
import { isHeavyParcelWeight } from '../../constraints/shipment-constraints.js';
import { DEFAULT_SERVICE_THRESHOLDS } from '../../reference/shipment-reference.js';
/** Catégorie principale qui discrimine les documents standard et lourd. */
export const shipmentCategorySchema = z.enum(['standard', 'heavy']);
/** Variante de parcours persistée, plus précise que la catégorie. */
export const shipmentTypeSchema = z.enum([
    'standard_shop',
    'standard_home',
    'befret_home',
    'heavy_specialist',
]);
export const shipmentEnvironmentSchema = z.enum(['development', 'staging', 'production']);
/** Service de collecte ou de dépôt utilisé sur la partie européenne. */
export const dpdServiceTypeSchema = z.enum(['shop_pickup', 'home_pickup', 'befret_home']);
/** Mode de remise BeFret à destination, distinct du service DPD en Europe. */
export const befretDeliveryMethodSchema = z.enum(['warehouse', 'home_delivery']);
/**
 * Point de décision unique entre les parcours standard et lourd. Le seuil vient
 * des données de référence partagées afin que le builder et les validateurs ne divergent pas.
 */
export function shipmentCategoryForWeight(weightKg) {
    if (!Number.isFinite(weightKg) || weightKg <= 0)
        throw new Error(`Poids invalide: ${weightKg}`);
    return isHeavyParcelWeight(weightKg, DEFAULT_SERVICE_THRESHOLDS.heavyParcelMinKg)
        ? 'heavy'
        : 'standard';
}
